import { useEffect, lazy, Suspense } from 'react';
import LoginPage from 'src/pages/login/loginPage';
import authService from 'src/services/authService';
import { UserRole, UserRoleGroup } from 'src/common/commonTypes';
import Header from 'src/layout/Header';
import Footer from 'src/layout/Footer';
import Menu from 'src/layout/Menu';
import { useAppDispatch, useAppSelector } from 'src/store/store';
import { selectUserInfo, userLoggedIn } from 'src/userInfo/slice';
import 'antd/dist/reset.css';
import { App } from 'antd';
import usersApiService from 'src/api/services/usersApiService';
import VisibilityFilter from 'src/components/visibilityFilter';

const LazySicRoutes = lazy(() => import('./routes/sicRoutes'));
const LazyAcRoutes = lazy(() => import('./routes/acRoutes'));
const LazyRaRoutes = lazy(() => import('./routes/raRoutes'));

function PspApp() {
    const dispatch = useAppDispatch();
    const hasToken = authService.hasValidToken();
    const userInfo = useAppSelector(selectUserInfo);

    useEffect(() => {
        if (hasToken && !userInfo) {
            const authData = authService.getData();
            if (authData) {
                usersApiService
                    .getCurrentUserInfo()
                    .then((user) => {
                        dispatch(
                            userLoggedIn({
                                userId: user.id,
                                userName: user.login,
                                userRole: UserRole[user.userRole as keyof typeof UserRole],
                                airlineCode: user.airlineIataCode,
                                airlineName: user.airlineName,
                                authorizationNumber: user.authorizationNumber,
                                hasRightToSign: user.hasRightToSign,
                                department: user.department,
                                isGeneralManager: user.isGeneralManager
                            })
                        );
                    })
                    .catch(() => {
                        authService.removeData();
                        window.location.reload();
                    });
            }
        }
    }, [dispatch, hasToken, userInfo]);

    if (!hasToken) {
        return <LoginPage />;
    }

    if (!userInfo) {
        return null;
    }

    return (
        <div className="app">
            <Header />
            <div className="app-body">
                <Menu />
                <div className="app-content">
                    <Suspense>
                        <VisibilityFilter role={UserRole.SIC}>
                            <LazySicRoutes />
                        </VisibilityFilter>
                        <VisibilityFilter role={UserRole.AC}>
                            <LazyAcRoutes />
                        </VisibilityFilter>
                        <VisibilityFilter role={UserRoleGroup.RaUsers}>
                            <LazyRaRoutes />
                        </VisibilityFilter>
                    </Suspense>
                </div>
            </div>
            <Footer />
        </div>
    );
}

// eslint-disable-next-line import/no-anonymous-default-export
export default () => (
    <App>
        <PspApp />
    </App>
);
